import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 7,
		fill: "var(--success-bg)",
		stroke: "var(--success-border)",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 8l2 2 4-4",
		stroke: "var(--success-text)",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export { SvgStatusSuccess as ReactComponent };
